/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration Layer (BOL) API
 * Business Orchestration layer (BOL) API. Public part, exposed to BOL client applications.  Glossary | Definition -- | -- <strong>Logistics Object</strong> | A resource in the BOL system that represents a business entity, such as a QuotationRequest, Quotation, or Service. Logistics Objects are managed through the BOL API and can be accessed or modified by Users based on their permissions i.e. based on their AD Entra ID roles and ACL (Access Control List) modes. <strong>Member</strong> | A data owner in the BOL system, uniquely identified by its `memberIdentifier`. Members are used to manage access control and ownership of Logistics Objects. <strong>User</strong> | A person or entity that interacts with the BOL system, typically through a client application, and beeing authenticated. Users are associated with Members and can perform actions on Logistics Objects based on their access level. User access token includes the Member identifier as part of roles claims. Each path in the API is protected by a custom role defined in AD Entra ID, and operations on Logistics Objects are protected by specific Access modes defined by members. <strong>Access Control</strong> | The mechanism by which the BOL system restricts access to API paths and resources based on the identity of the User and their associated Member. Access control is enforced through AD Entra ID roles and ACL (Access Control List) modes defined for every single Logistics Object. <strong>ACL (Access Control List)</strong> | A set of authorizations that define what actions a User can perform on a Logistics Object. The level of access granted to Users is determined by ACL modes defined in authorizations for specific Logistics Objects. ACL Modes are not directly associated with Users but rather with Members, which are the data owners of Logistics Objects. Each Logistics Object has an ACL that specifies the access modes for different Members. Members need to exist in the BOL system to be granted access to Logistics Objects. <strong>ACL Mode</strong> | The specific level of access control applied to a Logistics Object, determining what actions can be performed by Users. ACL modes are defined for each Logistics Object by `memberIdentifier` and include `READ`, `WRITE`, and `CONTROL`. Each mode includes access granted by the modes under it, so `CONTROL` includes `WRITE` and `READ`, and `WRITE` includes `READ`. <strong>Change Request</strong> | A request to modify a Logistics Object, which is processed by the BOL system. Change requests are created when a User wants to update an existing Logistics Object, and they are subject to approval and application by the system. All changes to Logistics Objects are done through change requests. This allows for a controlled and auditable process of modifications. <strong>Host</strong> | A server alias in the BOL system, used to abstract URI values internally. This allows for flexibility in the underlying infrastructure when migrating or changing server configurations. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A Document is a record that links to a digital document stored in a Content Management System that is managed by the document owner. Additional metadata is used to describe the document. If, as part of the process, a digital document is mandatory, the registry can be anticipated as a mandatory document, the link to the digital document being added later. A document registry can be added to all logistics objects.
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * URI of the shared document. The purpose of the shared data language is to provide a link to access any document, not to store them.
     * @type {string}
     * @memberof Document
     */
    cmsUri?: string;
    /**
     * Given name of the shared document
     * @type {string}
     * @memberof Document
     */
    documentName?: string;
    /**
     * Format of the document to be used by an appropriate reader. Most of the formats are standard like PDF, PNG, JPEG, DOCX, but the attribute is not limited to those standards.
     * @type {string}
     * @memberof Document
     */
    format?: string;
    /**
     * When creating an occurrence of a document, the document itself may not be available. However, when the document is required, the logistics process may be halted if the cmsURI property is missing at any point in time. For example, if a POD document is required, the invoicing process may be delayed if the link to the document is missing after delivery.
     * @type {boolean}
     * @memberof Document
     */
    isRequired?: boolean;
    /**
     * Indicates whether the document needs to be printed and physically attached to the goods along the logistics chain.
     * @type {boolean}
     * @memberof Document
     */
    suppliedWithGoods?: boolean;
    /**
     * Metadata to describe the type of document. A by default list is defined in the ontology... This list is not supposed to be complete.
     *                       Examples of values:
     *                       - CONTRACTUAL
     *                       - INVOICING
     *                       - CUSTOMS
     *                        
     * @type {string}
     * @memberof Document
     */
    documentType?: string;
    /**
     * Metadata to precise the document type. A by default list is defined in the ontology... This list is not supposed to be complete.
     *                          Examples of values for type CONTRACTUAL:
     *                          - AIR_WAYBILL
     *                          - BILL_OF_LADING
     *                          - CMR
     *                          - POD (for proof of delivery)
     *                          or for type CUSTOM:
     *                          - IMPORT_COMMERCIAL_INVOICE
     *                          - LICENCE
     *                          
     * @type {string}
     * @memberof Document
     */
    documentSubtype?: string;
}

/**
 * Check if a given object implements the Document interface.
 */
export function instanceOfDocument(value: object): value is Document {
    return true;
}

export function DocumentFromJSON(json: any): Document {
    return DocumentFromJSONTyped(json, false);
}

export function DocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): Document {
    if (json == null) {
        return json;
    }
    return {
        
        'cmsUri': json['cmsUri'] == null ? undefined : json['cmsUri'],
        'documentName': json['documentName'] == null ? undefined : json['documentName'],
        'format': json['format'] == null ? undefined : json['format'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'suppliedWithGoods': json['suppliedWithGoods'] == null ? undefined : json['suppliedWithGoods'],
        'documentType': json['documentType'] == null ? undefined : json['documentType'],
        'documentSubtype': json['documentSubtype'] == null ? undefined : json['documentSubtype'],
    };
}

export function DocumentToJSON(json: any): Document {
    return DocumentToJSONTyped(json, false);
}

export function DocumentToJSONTyped(value?: Document | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cmsUri': value['cmsUri'],
        'documentName': value['documentName'],
        'format': value['format'],
        'isRequired': value['isRequired'],
        'suppliedWithGoods': value['suppliedWithGoods'],
        'documentType': value['documentType'],
        'documentSubtype': value['documentSubtype'],
    };
}

